import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Present extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Present_1);

    this.setOrigin(0);
    this.vX = -180;

    this.active = false;
    this.isBonus = false;
  }

  reset (y) {
    this.y = y;
    this.x = this.scene.scale.width;
    this.active = true;
    this.setFrame(`Present_${Phaser.Math.Between(1,3)}`).setOrigin(0);
  }

  makeStar (y) {
    this.y = y;
    this.x = this.scene.scale.width;
    this.active = true;
    this.setFrame(UIAssetKeys._Star).setOrigin(0);
  }

  tick (dt) {
    this.x += dt * this.vX;
  }
}